import React from 'react';
import style from './errorScreen.css';
const kErrorMessageMap = {
    WEBGL_UNAVAILABLE: { title: 'This app requires WebGL and a modern browser' },
    SCENE_LOAD_FAILURE: { title: 'The scene failed to load. See the console for errors' },
    TRACK_PROCESS_FAILURE: {
        title: 'The track(s) in this scene are not yet processed',
        msg: 'Our servers may be experiencing heavy load. Try reloading this page in a few minutes.',
    },
    ION_TERRAIN_PROVIDER_FAILURE: {
        title: 'The Cesium Ion terrain servers are not responding',
        msg: 'This is likely a temporary problem. Try reloading this page in a few minutes.',
    },
    IMAGERY_PROVIDER_FAILURE: {
        title: 'The imagery servers are not responding',
        msg: 'This is likely a temporary problem. Try reloading this page in a few minutes.',
    },
    default: { title: 'An unknown fatal error occured' },
};
export default function ErrorScreen(errorId) {
    const error = kErrorMessageMap[errorId] || kErrorMessageMap.default;
    return (React.createElement("div", { className: style.errorWall },
        React.createElement("div", { className: style.errorContainer },
            React.createElement("h1", null, "oh no..."),
            React.createElement("h3", null, error.title),
            error.msg ? React.createElement("p", null, error.msg) : null)));
}
